import { render, staticRenderFns } from "./ConversationPopOver.vue?vue&type=template&id=81016f84&"
import script from "./ConversationPopOver.vue?vue&type=script&lang=js&"
export * from "./ConversationPopOver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ConversationPopOver.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports